export default "__VITE_ASSET__BZ2GV_Ph__"